import React from 'react';
import PropTypes from 'prop-types';

import TextExpander from 'src/app/components/TextExpander';
import Checkbox from 'src/app/components/Checkbox';
import agreementPropType from 'src/app/propTypes/agreement';
import 'src/app/components/AgreementComponent.scss';


class AgreementComponent extends React.PureComponent {

  toggleCheckbox = () => {
    const { toggle, agreement: { code } } = this.props;
    toggle(code);
  };

  render() {
    const { toggleCheckbox } = this;
    const { agreement, disabled } = this.props;
    const { code, text, extendedText, checked, links } = agreement;
    const anchors = links
      .map((link) => <a href={ link.href } key={ link.text } styleName="agreement-link">{link.text}</a>);

    return <Checkbox checked={ checked }
                     disabled={ disabled }
                     key={ code }
                     onClick={ toggleCheckbox }
                     data-test="checkbox-agreement"
    >
      <TextExpander primaryText={ text }
                    secondaryText={
                      <React.Fragment>
                        {extendedText}.{' '}
                        {
                          !!anchors.length &&
                          <React.Fragment>
                            Zapoznaj się z: {' '}
                            {
                              anchors.reduce((previous, current) => [previous, ', ', current])
                            }.
                          </React.Fragment>
                        }
                      </React.Fragment>
                    }
      />
    </Checkbox>;
  }
};


AgreementComponent.propTypes = {
  agreement: agreementPropType.isRequired,
  toggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

AgreementComponent.defaultProps = {
  disabled: false
};

export default AgreementComponent;
